module.exports = __webpack_public_path__ + "img/smart-office.64002331.svg";